module.exports = __webpack_public_path__ + "img/low-liquidity-dark.dbdd7711.svg";